import { useFeatureFlagContext } from 'context/FeatureFlagContext';

/**
 * Reads a feature flag from FeatureFlagContext.
 *
 * `defaultValue` is returned while evaluation is in flight (or the flag is
 * unknown). Use `true` for default-on flags (e.g. `studio-ai-chat`) so the
 * feature does not flash off during the initial evaluate call.
 */
export function useFeatureFlag(flagId: string, defaultValue = false): boolean {
  const { flags } = useFeatureFlagContext();
  return flags[flagId] ?? defaultValue;
}
